import FormSeguimiento from '../componentes/FormSeguimiento.vue'
import ListaSeguimiento from '../componentes/ListaSeguimiento.vue'
import CalendarioSeguimiento from '../componentes/CalendarioSeguimiento.vue'


const routes = [
    ...route('/guardar-seguimiento', FormSeguimiento, {
        Auth: true,
        ///req_admin: true
     }),
     ...route('/lista-seguimiento', ListaSeguimiento, {
       Auth: true,
       //req_admin: true
    }), ...route('/calendario-seguimiento', CalendarioSeguimiento, {
        Auth: true,
        //req_admin: true
     }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes